import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment1FuelTypeInfo } from "../state";


interface Assessment1DownloadCSVProps {
    fuelTypes: Assessment1FuelTypeInfo[];
}

function Assessment1DownloadCSV({ fuelTypes }: Assessment1DownloadCSVProps) {

    
    const csvData = [["Fuel", "Issue", "Action Plan"]];
        let rowIndex:number = 1;
        //iterate fuel types
        fuelTypes.map(fuel => {
            if(fuel.IncludingEnergyUseChargesFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Expenditure amounts reported vendors should include energy usage charges"
                                      , fuel.IncludingEnergyUseChargesDesc];
                rowIndex++; 
            }
            if(fuel.IncludingEnergyDeliveryChargesFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Expenditure amounts reported vendors should include include delivery, fixed charges, and taxes."
                                      , fuel.IncludingEnergyDeliveryChargesDesc];
                rowIndex++; 
            }
            if(fuel.IncludeSupplierChargesFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Expenditure amounts reported vendors should include include supplier charges."
                                      , fuel.IncludeSupplierChargesDesc];
                rowIndex++; 
            }
 
            if(fuel.IncludingEnergyOptionalChargesFlag !== "N")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Expenditure amounts reported by vendors should NOT include optional charges."
                                      , fuel.IncludingEnergyOptionalChargesDesc];
                rowIndex++; 
            }
            if(fuel.Including12MonthOnlyFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors should be reporting for a 12 month period only."
                                      , fuel.Including12MonthOnlyDesc];
                rowIndex++; 
            }
            if(fuel.IncludingComplete12MonthFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors should be reporting for a full 12 month period."
                                      , fuel.IncludingComplete12MonthDesc];
                rowIndex++; 
            }
            if(fuel.IndicatingLessThan12MonthFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"If a client`s expenditure data represents less than 12-months for any reason, this needs to be indicated and accounted when calculating your average expenditures."
                                      , fuel.IndicatingLessThan12MonthDesc];
                rowIndex++; 
            }
            if(fuel.ReportingAfterDiscountsFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors should be sending billing data after low-income discounts have been applied."
                                      , fuel.ReportingAfterDiscountsDesc];
                rowIndex++; 
            }
            if(fuel.CheckOutliersFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors should check outliers in the data they report to you to ensure that they did not make any errors."
                                      , fuel.CheckOutliersDesc];
                rowIndex++; 
            }
            if(fuel.IncludeOnlyAmountBilledFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Vendors should only include the new amounts that households are billed each month, and not the total amount owed."
                                      , fuel.IncludeOnlyAmountBilledDesc];
                rowIndex++; 
            }
            if(fuel.SignificantSupplierChargesFlag !== "Y")
            {
                csvData[rowIndex] = [fuel.description
                                      ,"You need to know whether a significant portion of your households are being assessed third-party supplier charges."
                                      , fuel.SignificantSupplierChargesDesc];
                rowIndex++; 
            }
            if(fuel.OtherReasonDesc !== "" &&  fuel.OtherReasonDesc !== null)
            {
                csvData[rowIndex] = [fuel.description
                                      ,"Potential data reliability issue cannot be explained by the most common reasons."
                                      , fuel.SignificantSupplierChargesDesc];
                rowIndex++; 
            }
 

            if(fuel.computedAverageExpenditure === 0
                && fuel.totalAssistedhHNum>0
                && (fuel.ZeroAvgExpenditureDataReasonDesc != ''
                      && fuel.ZeroAvgExpenditureDataReasonDesc != null)){
                csvData[rowIndex] = [fuel.description
                                      ,"You assisted households that used but did NOT collect and/or report data."
                                      , fuel.ZeroAvgExpenditureDataReasonDesc];
                rowIndex++; 
            }

        });
    return (
      <CSVLink data={csvData} filename="ElectricBaseloadAssessment1.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment1DownloadCSV;
